<header
  class="layout__booking-header layout__header--override white-bg surface-primary nordic-blue-900-text text-icon-primary elevation-level-1"
>
  <div class="grid-col-12 no-row-gap grid-max-width">
    <div class="col-f">
      <fin-header-boxes [homeLink$]="homeLink$" (homeClick)="onHomeClick($event)">
        <div left class="flex flex--start flex--self-center">
          @if (showHamburgerMenu()) {
            <fcom-icon-button
              class="nav ms-medium-r"
              [icon]="{ name: SvgLibraryIcon.MENU_LIST }"
              [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
              [size]="IconButtonSize.MEDIUM"
              [aria]="{ label: 'menu.open' | finLocalization }"
              (clickBtn)="menuClick.emit($event)"
            />
          }
          @if (showLanguageSelector() && !isInsideNativeWebView()) {
            <div class="dn-laptop-up">
              <fin-language-selector
                class="mobile-language-selector"
                [context]="LANGUAGE_SELECTOR_CONTEXT"
                [skipRedirect]="true"
                (applySelection)="countryChanged($event)"
              />
            </div>
          }
          @if (forceShowBack() || isInsideNativeWebView()) {
            <fcom-icon-button
              [class.hidden]="!showBack()"
              class="back"
              [class.ms-medium-r]="forceShowBack()"
              [disabled]="!showBack()"
              [icon]="{ name: SvgLibraryIcon.CHEVRON_LEFT }"
              [theme]="IconButtonTheme.LIGHT_TERTIARY_GHOST"
              [size]="IconButtonSize.MEDIUM"
              [aria]="{ label: 'actions.back' | finLocalization }"
              (clickBtn)="onBackClick($event)"
            />
          }
          <a
            class="home-link desktop-icon ms-large-r dn-laptop-down flex"
            [attr.aria-label]="'actions.home' | finLocalization"
            [class.disabled]="isInsideNativeWebView()"
            [href]="homeLink()"
            (click)="onHomeClick($event)"
          >
            <fcom-icon
              class="finnair-home nordic-blue-900-text text-icon-primary"
              [category]="IconLibrary.CUSTOM"
              [name]="CustomIcon.FINNAIR_LOGO"
            />
          </a>
        </div>

        @if (hasBreadcrumbsToRender()) {
          <div center class="breadcrumb-wrapper flex flex-1">
            <ul class="breadcrumbs flex flex-1 dn-laptop-down">
              @for (breadcrumb of breadCrumbsWithoutSeat(); track breadcrumb.id; let i = $index) {
                <li
                  class="breadcrumb phase flex-1 flex flex--center"
                  [class.selectable]="i < activeIndex()"
                  [class.active]="breadcrumb.active"
                >
                  <button
                    role="link"
                    class="flex flex-1 flex--center"
                    (click)="onBreadcrumbClick(breadcrumb, i)"
                    [title]="breadcrumb.name"
                    [disabled]="breadcrumb.disabled || i > activeIndex()"
                  >
                    <div class="phase-block flex--nogrow rounded"></div>
                    <div
                      class="phase-text flex-1"
                      [ngClass]="
                        breadcrumb.active
                          ? 'heather-700-text text-icon-primary'
                          : 'nordic-blue-900-text text-icon-primary'
                      "
                    >
                      {{ breadcrumb.name }}
                    </div>
                    <span>
                      @if (i < activeIndex()) {
                        <span class="is-vishidden">{{ phasesAria().pastStep }}</span>
                      }
                      @if (breadcrumb.active) {
                        <span class="is-vishidden">{{ phasesAria().currentStep }}</span>
                      }
                      @if (i > activeIndex()) {
                        <span class="is-vishidden">{{ phasesAria().futureStep }}</span>
                      }
                    </span>
                  </button>
                </li>
              }
            </ul>
          </div>
        }

        <div right class="flex flex--end flex--self-center align-right" data-hj-suppress data-dd-privacy="hidden">
          @if (showLanguageSelector() && !isInsideNativeWebView()) {
            <div class="dn-laptop-down">
              <fin-language-selector
                [context]="LANGUAGE_SELECTOR_CONTEXT"
                [skipRedirect]="true"
                (applySelection)="countryChanged($event)"
              />
            </div>
          }
          <div class="login-button-wrapper" [class.hidden]="!showLogin()">
            <fin-login-button
              data-testid="booking-header-finnair-plus-login-button"
              class="font-body-1 grow flex nordic-blue-900-text text-icon-primary font-body-medium"
              [showName]="true"
              [trackingContext]="GaContext.TOP_NAVIGATION"
              (click)="onLoginButtonClick($event)"
            />
          </div>
        </div>
      </fin-header-boxes>
    </div>
  </div>
</header>
